import { HttpClient } from '@angular/common/http';
import { environment } from '@env';

export class RequestService {
  constructor(protected http: HttpClient) {
  }

  protected webBase: string = `${environment.WEB_URL}`;
  
  protected apiUrl(path: string) {
    return `${environment.API_URL}/${path}`;
  }
}
